<template>
  <v-layout class="footer" pt-2 px-4>
    <table pt-2 px-4>
      <thead>
        <tr>
          <th>
            <h5 class="display-12 black--text font-weight-medium pb-1 text-right">
              <strong>קטגוריה</strong>
            </h5>
          </th>
          <th class="pr-9">
            <h5 class="display-12 black--text font-weight-medium pb-1 text-right">
              תחומים
            </h5>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(jobCategorie, index) in categories" :key="`category-${index}`">
          <td>
            <v-row class="no-gutters mb-2">
              <v-col class="pr-0">
                <DrBtn
                  class="btn-link"
                  type-btn="catBtn"
                  :goToUrl="jobCategorie['Link']"
                  :targetUrl="'_self'"
                >
                  <span class="display-12">
                    {{ jobCategorie['NameInHebrew'] }}
                  </span>
                </DrBtn>
              </v-col>
            </v-row>
          </td>
          <td>
            <v-row class="no-gutters mb-2 pr-9">
              <v-col
                class="flex-grow-0 ml-2"
                v-for="(jobSubCategorie, innerIndex) in categories[index]
                  .subCategories"
                :key="`subCategory-${innerIndex}`"
              >
                <DrBtn
                  class="btn-link"
                  type-btn="catBtn"
                  :goToUrl="jobSubCategorie['Link']"
                  :targetUrl="'_self'"
                >
                  <span class="display-12">
                    {{ jobSubCategorie['NameInHebrew'] }}
                  </span>
                </DrBtn>
              </v-col>
            </v-row>
          </td>
        </tr>
      </tbody>
    </table>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      searchStr: '',
    };
  },
  props: {
    isSingleJob: Boolean,
    jobSubCategories: {
      type: Array,
      required: false,
      default: () => [],
    },
    jobCategories: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    categories() {
      // create subCategorie for each categorie
      return this.jobCategories.map(jobCategorie => ({
        ...jobCategorie,
        subCategories: this.jobSubCategories.filter(subCat => subCat.Categories.indexOf(jobCategorie.Code) !== -1) || []
      }));
    },
  },
};
</script> 

<style lang="scss" scoped>
.footer {
  overflow: hidden;
  margin-top: 5px;
  border-top: 2px solid #fff;
}

.theme--light.v-footer {
  background: transparent;
  border-top: 1px solid #fff;
  padding: 10px 0;
}

.catRow {
  border-left: 2px solid #fff;
  padding-left: 5px;
}

.scopeRow {
  padding-right: 20px;
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #f5f5f5 !important;
}

.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: transparent;
}

.v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
  will-change: box-shadow;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.theme--light.v-btn.v-btn--disabled {
  color: #000 !important;
}

td {
  vertical-align: top;
}
.btn-link {
  margin: 0 0 5px 5px;
  text-align: right;
}

@media screen and (max-width: 600px) {
  .footer {
    align-items: baseline !important;
  }
  .scopeRow {
    padding: 0 10px 0 0;
  }
}
</style>

